/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RocketQuickActionsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rocket Quick Actions',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m6.17871,18.82227c-.19238,0-.38379-.07324-.53027-.21973-.29297-.29297-.29297-.76855,0-1.06055l.93848-.9375c.29297-.29395.76758-.29199,1.06055,0,.29297.29297.29297.76855,0,1.06055l-.93848.9375c-.14648.14648-.33887.21973-.53027.21973Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m1.91797,14.60254c-.19238,0-.38379-.07324-.53027-.21973-.29297-.29297-.29297-.76855,0-1.06055l.93848-.9375c.29395-.29395.76855-.29199,1.06055,0,.29297.29297.29297.76855,0,1.06055l-.93848.9375c-.14648.14648-.33887.21973-.53027.21973Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m2.49805,18.25195c-.19141,0-.38281-.07227-.5293-.21777-.29297-.29297-.29492-.76758-.00293-1.06152l2.49609-2.50977c.29395-.29199.76758-.29492,1.06152-.00293.29297.29297.29492.76758.00293,1.06152l-2.49609,2.50977c-.14746.14648-.33984.2207-.53223.2207Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m18.17969,1.66211c-.63672-.58496-1.5752-.78809-2.78125-.61133-2.32446.34424-4.17236,1.60938-5.65601,3.021-.3728-.04517-.74731-.07251-1.09302-.07178-2.9873.0293-5.75684,1.64844-7.40918,4.33301-.30566.49609-.31934,1.11816-.03516,1.62109.28223.49902.79199.7959,1.36035.7959h2.80249c.0874.51196.32861.99683.71216,1.37988l1.79004,1.79004c.38696.3877.87158.62378,1.37988.71143v2.78174c-.00488.58105.29199,1.09766.7959,1.38184.24121.13574.50977.2041.7793.2041.29102,0,.58398-.08008.84277-.23926,2.68359-1.65234,4.30273-4.42188,4.33203-7.40918.00317-.36157-.02563-.73145-.07178-1.10205.0708-.07422.15381-.1499.22217-.22412,1.55176-1.68066,2.46094-3.40625,2.7793-5.27734.23145-1.35938-.02832-2.42578-.75-3.08496Zm-12.38965,7.17773c-.07715.11133-.14062.22559-.19824.34375l-.00293.00586c-.00952.01978-.01465.04053-.02368.06055h-2.94165c-.0791,0-.12988-.08984-.08862-.15723,1.28149-2.08838,3.48608-3.45483,5.82349-3.57056-.10645.12231-.21875.24634-.32031.36646-.7207.85156-1.47656,1.84375-2.24805,2.95117Zm5.11768,8.62207c-.06738.04175-.15771-.00903-.15771-.08813v-2.9353c.14136-.06445.27979-.13794.41113-.22949,1.28613-.896,2.37158-1.74805,3.31689-2.57935-.11694,2.34155-1.46509,4.52954-3.57031,5.83228Zm6.54346-12.9668c-.26855,1.57617-1.05371,3.05176-2.40234,4.51172-1.15918,1.25488-2.71094,2.55371-4.74512,3.97168-.42969.2998-1.00586.24805-1.37305-.11914l-1.79004-1.79102c-.32031-.31934-.40137-.81055-.20312-1.22363.02539-.05078.05176-.10156.08398-.14844.74414-1.06738,1.47168-2.02246,2.16113-2.83887,1.6123-1.90527,3.63672-3.90918,6.43457-4.32227.51074-.07617,1.19141-.0957,1.5498.2334.43457.39746.36426,1.25293.28418,1.72656Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m14.5,6.75c0,.69036-.55964,1.25-1.25,1.25s-1.25-.55964-1.25-1.25c0-.69036.55964-1.25,1.25-1.25s1.25.55964,1.25,1.25Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
